import type { ConsentDoc } from '@/shared/data-types';
import { Markdown } from '@/shared/ui';

export interface ConsentDocBodyProps {
  consent: ConsentDoc;
}

/**
 * 약관 원문 본문 — 가시 제목(h1, BE `name`) + markdown 원문. 이미 손에 쥔 문서를 렌더하는 표면
 * (`ConsentModal`)과 ID 로 집어 오는 표면(`ConsentDocContent`)이 **같은 모양**을 갖도록 공유한다.
 * `content` 는 제목 줄(`#`) 없이 본문만 오는 걸 가정하고 그대로 렌더 — FE 는 텍스트를 고치지 않는다
 * (BE content 가 SSOT, 결함 은폐 방지).
 *
 * 다만 **들여쓰기 코드블록 판정은 끈다**(`indentedCode={false}`) — BE 약관 원문이 들여쓰기를 서식으로
 * 쓰는 경우가 있어(CLU01 은 blockquote 이후 전 줄이 4칸) CommonMark 기본 규칙대로면 본문 전체가
 * 코드블록으로 뒤집힌다. 원문은 손대지 않고 **파서 구성만** 바꾸는 선택 — 약관에 fenced code 가 올 일은
 * 없으니 잃는 표현이 없다.
 */
export function ConsentDocBody({ consent }: ConsentDocBodyProps) {
  return (
    <>
      <h1 className="mb-4 text-lg font-bold text-foreground">{consent.name}</h1>
      <Markdown indentedCode={false}>{consent.content}</Markdown>
    </>
  );
}
